
import { handlerAccesNonAuthorise } from '@/utils/auth/handler-acces-non-authorise';
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'Login',
  data () {
    return {
      loading: false,
      error: null
    };
  },
  created () {
    this.loadUser()
      .then(() => {
        this.$router.push(this.$route.query.redirectFrom as string || { name: 'main' });
      })
      .catch(() => {});
  },
  methods: {
    ...mapActions({ sessionLogin: 'session/login', loadUser: 'user/loadUser', setSesionInfos: 'user/setSessionInfos' }),
    login () {
      this.error = null;
      this.loading = true;

      this.sessionLogin({ mode: 'redirect', redirectUri: '/auth/login-success' + window.location.search })
        .then(success => {
          if (success) {
            return this.loadUser()
              .then(user => {
                this.$gtag.event('login', {
                  category: 'authentification',
                  label: user.username
                });
                // eslint-disable-next-line no-console
                console.debug('log in', user);
                // this.$ga.event({
                //   eventCategory: 'session',
                //   eventAction: 'login',
                //   eventLabel: user.username
                // });
                this.$router.push(this.$route.query.redirectFrom as string || { name: 'main' });
              });
          }
        })
        .catch(error => {
          if (handlerAccesNonAuthorise(error, true)) {
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
